import { z } from 'zod';
import { apiClient } from '@/core/api/client';
import { ENDPOINTS } from '@/core/api/endpoints';
import { AplicacionDescuentoSchema, PagoSchema, PagosDeReservaSchema, } from '@/data/dto/pago';
export const pagosApi = {
    async listarDeReserva(reservaId) {
        const res = await apiClient.get(`${ENDPOINTS.reservas}/${reservaId}/pagos`);
        return PagosDeReservaSchema.parse(res.data);
    },
    async registrar(reservaId, datos) {
        const res = await apiClient.post(`${ENDPOINTS.reservas}/${reservaId}/pagos`, {
            metodo: datos.metodo,
            monto: datos.monto,
            pdvId: datos.pdvId,
            observaciones: datos.observaciones || null,
        });
        return PagoSchema.parse(res.data);
    },
    async reversar(pagoId, motivo) {
        const res = await apiClient.post(`${ENDPOINTS.pagos}/${pagoId}/reverso`, {
            motivo: motivo ?? null,
        });
        return PagoSchema.parse(res.data);
    },
    async listarDescuentos(reservaId) {
        const res = await apiClient.get(`${ENDPOINTS.reservas}/${reservaId}/descuentos`);
        return z.object({ items: z.array(AplicacionDescuentoSchema) }).parse(res.data).items;
    },
    async aplicarDescuento(reservaId, datos) {
        const res = await apiClient.post(`${ENDPOINTS.reservas}/${reservaId}/descuentos`, {
            reglaId: datos.reglaId ?? null,
            origen: datos.origen ?? null,
            descripcion: datos.descripcion ?? null,
            pct: datos.pct ?? null,
            monto: datos.monto ?? null,
        });
        return AplicacionDescuentoSchema.parse(res.data);
    },
    async quitarDescuento(reservaId, aplicacionId) {
        await apiClient.delete(`${ENDPOINTS.reservas}/${reservaId}/descuentos/${aplicacionId}`);
    },
};
